<div class="selector-container" [ngStyle]="{ 'width':width }">
  <div class="select-custom"
    (click)="toggleFocus()"
    [ngClass]="{ 'focused' : focused }"
    (mouseenter)="onMouseOver()"
    (mouseleave)="onMouseLeft()">
    @if (selectedIndex.length == 0) {
      <div class="selected-item placeholder"
        >
        {{ placeHolder }}
      </div>
    }
    @if (selectedIndex.length > 0) {
      <div class="selected-items"
        >
        @for (i of selectedIndex; track i) {
          <div (click)="$event.stopPropagation()">{{ items[i] }}
            <img src="assets/img/icons/new_icons/cancel_white.png"
              (click)="removeItem(i,$event)">
            </div>
          }
          @if ( selectedIndex.length -1 > 0) {
            <p class="select-count"
              >
              {{ '+' + (selectedIndex.length -1) }}
            </p>
          }
        </div>
      }
      <i class="arrow-down"
        (click)="toggleFocus()"
      [ngClass]="{ 'arrow-focused' : hovered || focused }"></i>
    </div>
    @if (focused) {
      <div class="select-custom-options"
        (mouseleave)="hideDropdown()"
        >
        @if (showSelectAll) {
          <div (click)="toggleSelectAll()">
            <input type="checkbox"
              class="checkbox"
              [(ngModel)]="selectAll"
              (ngModelChange)="onSelectAll()"/>
              <div>Select All</div>
            </div>
          }
          @for (i of items; track i; let index = $index) {
            <div (click)="onItemSelected(index)">
              <input type="checkbox"
                [checked]=" selectedIndex.includes(index)"/>
                <div>{{ i }}</div>
              </div>
            }
          </div>
        }
      </div>
